module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Keine Events gefunden":"Keine Events gefunden","Slot":"Slot","Slots":"Slots","Anmeldungen":"Anmeldungen"}}')
  delete Component.options._Ctor
}
